import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiwrapperService } from '../../../services/apiwrapper.service';
import { DataManipulationService } from '../../../services/data-manipulation.service';

@Component({
  selector: 'app-create-workspace-modal',
  templateUrl: './create-workspace-modal.component.html',
  styleUrls: ['./create-workspace-modal.component.scss']
})
export class CreateWorkspaceModalComponent {
  createWorkspaceForm = new FormGroup({
    workspaceName: new FormControl('', [
      Validators.required,
      Validators.minLength(1)]),
  });

  constructor(private dialogRef: MatDialogRef<any>, private apiwrapper: ApiwrapperService,
              private data: DataManipulationService) { }

  close(result?: any) {
    this.dialogRef.close(result);
  }

  createWorkspace() {
    this.data.showLoading();
    if (this.createWorkspaceForm.valid) {
      // check if workspace exits
      this.apiwrapper.checkWorkspace(this.createWorkspaceForm.value.workspaceName).subscribe(
        res => {
          // create workspace
          this.apiwrapper.postCreateWorkspace(this.createWorkspaceForm.value.workspaceName).subscribe(
            r => {
              this.apiwrapper.patchWorkspace(r.uuid, {onboardingStep: 'done'})
                // tslint:disable-next-line:no-shadowed-variable
                .subscribe(res => {
                  this.data.hideLoading();
                  this.close(true);
                  this.data.showAlert('Your workspace was created successfully.');
                }, err => {
                  this.data.hideLoading();
                  this.data.showAlertError(err.error.error.messages[0]);
                });
            },
            err => {
              this.data.hideLoading();
              if (err.status === 401) {
                // this.apiwrapper.refreshToken();
              }
              this.data.showAlertError(err.error.error.messages[0]);
            }
          );
        }, err => {
          this.data.hideLoading();
          this.data.showAlertError(err.error.error.messages[0]);
        }
      );
    } else {
      this.data.hideLoading();
      this.data.showAlertError('Please choose a name for your workspace.');
    }
  }
}
